import { getI18nState } from '@web/i18n/state'

import { desktopApp } from './desktop_app'

export function initializeDesktopLocale() {
  if (!desktopApp) {
    return
  }

  desktopApp.setLocales(getI18nState()!.locales)
}
